export default "__VITE_ASSET__mxq1$fn4__"